/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { ActionRequest } from '@wit/vtv-x-foundation-lib';
import { StoreState } from 'store/store';

// ACTIONS
export enum ActionType {
  CHANGED = 'location/changed',
  SET_STATE = 'location/setState',
}

type State = unknown;

type LocationChanged = ActionRequest<ActionType.CHANGED, { path: string }>;
type SetState = ActionRequest<ActionType.SET_STATE, { path: string; state: State }>;
type Actions = LocationChanged | SetState;

const Actions = {
  locationChanged: (path: string): LocationChanged => ({ type: ActionType.CHANGED, meta: { path } }),
  setState: (path: string, state: State): SetState => ({ type: ActionType.SET_STATE, meta: { path, state } }),
};

export const ActionCreators = {
  locationChanged: Actions.locationChanged,
  setState: Actions.setState,
};

//
// REDUCER
//

type Path = string;
type ReducerState = {
  from: Path;
  // don't use path directly, it's not synchronous, use useLocation hook instead
  path: Path;
  pathState: Record<Path, State>;
};

const initialState: ReducerState = { from: '', path: '', pathState: {} };

export default function reducer(state = initialState, action: Actions): ReducerState {
  switch (action.type) {
    case ActionType.CHANGED:
      return {
        ...state,
        from: state.path,
        path: action.meta.path,
      };
    case ActionType.SET_STATE:
      return {
        ...state,
        pathState: { ...state.pathState, [action.meta.path]: action.meta.state },
      };

    default:
      return state;
  }
}

//
// SELECTORS
//

export const Selectors = {
  from: (state: StoreState): string => state.router.from,
  state: (state: StoreState, path: string): State | undefined => state.router.pathState[path],
};
